export const GET_BASIC_DATA_REQUEST = 'GET_BASIC_DATA_REQUEST';
export const GET_BASIC_DATA_SUCCESS = 'GET_BASIC_DATA_SUCCESS';
export const GET_BASIC_DATA_FAIL = 'GET_BASIC_DATA_FAIL';
